// 手机号国家/地区支持（国际短信）
// 规则与后端 backend/services/phoneFormat.js 镜像，改动须两边同步：
//   中国大陆 → 裸号 13800138000（不加 +86，兼容全部已有用户）
//   国际号   → E.164：国家码 + 去掉本地前导0的号码（如 090-1234-5678 → +819012345678）

export const COUNTRIES = [
  { cc: '+86', flag: '🇨🇳', name: '中国大陆', minLen: 11, maxLen: 11 },
  { cc: '+81', flag: '🇯🇵', name: '日本',     minLen: 9,  maxLen: 11 },
  { cc: '+65', flag: '🇸🇬', name: '新加坡',   minLen: 8,  maxLen: 8  },
];

const CN_MOBILE_RE = /^1[3-9]\d{9}$/;

/** 本地输入是否合法（local 为用户在输入框里敲的当地号码，可含空格/连字符） */
export function validLocalPhone(cc, local) {
  const digits = String(local || '').replace(/[\s\-()]/g, '');
  if (!/^\d+$/.test(digits)) return false;
  if (cc === '+86') return CN_MOBILE_RE.test(digits);
  const c = COUNTRIES.find(x => x.cc === cc);
  if (!c) return false;
  const national = digits.replace(/^0+/, '');
  return national.length >= c.minLen && national.length <= c.maxLen;
}

/** 组合成统一存储格式：+86 → 裸号；其他 → E.164（与后端 normalizePhone 结果一致） */
export function composePhone(cc, local) {
  const digits = String(local || '').replace(/[\s\-()]/g, '');
  if (cc === '+86') return digits;
  return cc + digits.replace(/^0+/, '');
}

/** 各国当地号码输入示例（placeholder 用） */
export function localPlaceholder(cc) {
  if (cc === '+81') return '09012345678';
  if (cc === '+65') return '91234567';
  return '13800138000';
}
